module.exports = __webpack_public_path__ + "img/yxrwgj.3a51711.png";